//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS ,GameStatus , BetType  } from './enum';

export default {
  name: 'CurrentGame',
  props: {
    chickenRoadState: {
      type: Object,
      default: () => ({
        topGames: () => []
      })
    }
  },
  data() {
    return {
    };
  },
  computed: {
    topGame() {
      if (!this.chickenRoadState) return null;
      const games = typeof this.chickenRoadState.topGames === 'function'
        ? this.chickenRoadState.topGames()
        : (this.chickenRoadState.topGames || []);
      return games.length > 0 ? games[0] : null;
    },
    displayData() {
      const game = this.topGame;
      if (!game) return null;

      const winItem = game.winItem || null;
      const coefficient = game.ratio ? parseFloat(game.ratio).toFixed(2) : '1.00';

      let winAmount = '0.00';
      if (game.winItemPrice) {
        winAmount = parseFloat(game.winItemPrice).toFixed(2);
      } else if (game.ratio && game.amount) {
        winAmount = (parseFloat(game.amount) * parseFloat(game.ratio)).toFixed(2);
      }

      return {
        user: game.user,
        winItem,
        coefficient,
        winAmount,
        platformsCount: game.currentStep
      };
    },
    avatarUrl() {
      if (!this.displayData.user) return '';
      return this.$imgfilter(this.displayData.user.photoUrl) || require(`@/assets/images/user/ava_none.jpg`);
    },
    winItemImgSrc() {
      if (!this.displayData || !this.displayData.winItem) return '';
      return this.displayData.winItem.itemPic;
    }
  },
  mounted() {
    this.checkMediaQuery();
    window.addEventListener('resize', this.checkMediaQuery);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMediaQuery);
  },
  methods: {
    checkMediaQuery() {
      this.isLg = window.innerWidth <= 992;
    }
  }
};
